type Listener = (height: number) => void;

/** Fallback matches collapsed sticky footer + breathing room. */
let currentHeight = 72;
const listeners = new Set<Listener>();

export function publishStickyFooterHeight(height: number) {
  const next = Math.max(0, Math.round(height));
  if (next === currentHeight) return;
  currentHeight = next;
  listeners.forEach((listener) => listener(currentHeight));
}

export function getStickyFooterHeight() {
  return currentHeight;
}

export function subscribeStickyFooterHeight(listener: Listener) {
  listeners.add(listener);
  listener(currentHeight);
  return () => {
    listeners.delete(listener);
  };
}
